import { CommonRequestCertificateInterface } from 'front-office/view-models/common-certificate-form';
import { createContext } from 'react';

export interface AccountHolderStorage {
  values?: CommonRequestCertificateInterface;
  setValues: (values: CommonRequestCertificateInterface) => void;
}

const AccountHolderContext = createContext<AccountHolderStorage>({
  setValues: () => {
    return;
  },
});

export default AccountHolderContext;
